import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "./locales/en/common.json";
import enPolicies from "./locales/en/policies.json";
import enDashboard from "./locales/en/dashboard.json";
import enApplications from "./locales/en/applications.json";
import enPolicySpec from "./locales/en/policySpec.json";
import enSandbox from "./locales/en/sandbox.json";
import enSettings from "./locales/en/settings.json";
import enHeader from "./locales/en/header.json";
import enErrors from "./locales/en/errors.json";
import enOrg from "./locales/en/org.json";
import enManagement from "./locales/en/management.json";

import zhCommon from "./locales/zh/common.json";
import zhPolicies from "./locales/zh/policies.json";
import zhDashboard from "./locales/zh/dashboard.json";
import zhApplications from "./locales/zh/applications.json";
import zhPolicySpec from "./locales/zh/policySpec.json";
import zhSandbox from "./locales/zh/sandbox.json";
import zhSettings from "./locales/zh/settings.json";
import zhHeader from "./locales/zh/header.json";
import zhErrors from "./locales/zh/errors.json";
import zhOrg from "./locales/zh/org.json";
import zhManagement from "./locales/zh/management.json";

import jaCommon from "./locales/ja/common.json";
import jaPolicies from "./locales/ja/policies.json";
import jaDashboard from "./locales/ja/dashboard.json";
import jaApplications from "./locales/ja/applications.json";
import jaPolicySpec from "./locales/ja/policySpec.json";
import jaSandbox from "./locales/ja/sandbox.json";
import jaSettings from "./locales/ja/settings.json";
import jaHeader from "./locales/ja/header.json";
import jaErrors from "./locales/ja/errors.json";
import jaOrg from "./locales/ja/org.json";
import jaManagement from "./locales/ja/management.json";

import thCommon from "./locales/th/common.json";
import thPolicies from "./locales/th/policies.json";
import thDashboard from "./locales/th/dashboard.json";
import thApplications from "./locales/th/applications.json";
import thPolicySpec from "./locales/th/policySpec.json";
import thSandbox from "./locales/th/sandbox.json";
import thSettings from "./locales/th/settings.json";
import thHeader from "./locales/th/header.json";
import thErrors from "./locales/th/errors.json";
import thOrg from "./locales/th/org.json";
import thManagement from "./locales/th/management.json";

export const SUPPORTED_LANGUAGES = ["en", "zh", "ja", "th"] as const;

export const I18N_NAMESPACES = [
  "common",
  "policies",
  "dashboard",
  "applications",
  "policySpec",
  "sandbox",
  "settings",
  "header",
  "errors",
  "org",
  "management",
] as const;

const resources = {
  en: {
    common: enCommon,
    policies: enPolicies,
    dashboard: enDashboard,
    applications: enApplications,
    policySpec: enPolicySpec,
    sandbox: enSandbox,
    settings: enSettings,
    header: enHeader,
    errors: enErrors,
    org: enOrg,
    management: enManagement,
  },
  zh: {
    common: zhCommon,
    policies: zhPolicies,
    dashboard: zhDashboard,
    applications: zhApplications,
    policySpec: zhPolicySpec,
    sandbox: zhSandbox,
    settings: zhSettings,
    header: zhHeader,
    errors: zhErrors,
    org: zhOrg,
    management: zhManagement,
  },
  ja: {
    common: jaCommon,
    policies: jaPolicies,
    dashboard: jaDashboard,
    applications: jaApplications,
    policySpec: jaPolicySpec,
    sandbox: jaSandbox,
    settings: jaSettings,
    header: jaHeader,
    errors: jaErrors,
    org: jaOrg,
    management: jaManagement,
  },
  th: {
    common: thCommon,
    policies: thPolicies,
    dashboard: thDashboard,
    applications: thApplications,
    policySpec: thPolicySpec,
    sandbox: thSandbox,
    settings: thSettings,
    header: thHeader,
    errors: thErrors,
    org: thOrg,
    management: thManagement,
  },
};

const readInitialLanguage = (): string => {
  if (typeof window === "undefined") return "en";
  try {
    const stored = window.localStorage.getItem("xecguard.language");
    if (stored && (SUPPORTED_LANGUAGES as readonly string[]).includes(stored)) {
      return stored;
    }
  } catch {
    // localStorage unavailable; fall back to default.
  }
  return "en";
};

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: readInitialLanguage(),
    fallbackLng: "en",
    defaultNS: "common",
    ns: I18N_NAMESPACES as unknown as string[],
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18n;
